import { isOverdue, type ServerTask } from '../../data/tasks';
import type { Store } from '../../data/types';
import type { CsvCell } from '../csv';
import { isoToCompanyDay } from '../dates';
import { taskStatusLabel } from '../../data/taskRules';

/**
 * CSV rows for the Tasks list (B6, owner rulings 2026-10-25) — the tasks the
 * list is showing, filters and sort applied, as plain values (YYYY-MM-DD
 * dates in the Eastern calendar, like the cards). Pure.
 */

export const TASKS_CSV_HEADER = [
  'Store number', 'Store', 'District', 'Title', 'Status', 'Assigned to', 'Due date', 'Overdue', 'Created',
  'Completed at', 'Completed by', 'Proof required', 'More time asked', 'Files',
] as const;


export function tasksCsvRows(tasks: readonly ServerTask[], storeById: ReadonlyMap<number, Store>, now: Date = new Date()): CsvCell[][] {
  return tasks.map((t) => {
    const s = storeById.get(t.storeId);
    return [
      s?.storeNumber ?? '',
      s?.name ?? '',
      s?.district ?? '',
      t.title,
      taskStatusLabel(t.status),
      t.assignedTo,
      isoToCompanyDay(t.dueDate),
      isOverdue(t, now),
      isoToCompanyDay(t.createdAt),
      t.status === 'complete' ? isoToCompanyDay(t.completedAt) : '',
      t.status === 'complete' ? t.completedByName : '',
      Boolean(t.proofRequired),
      t.extensionRequest ? isoToCompanyDay(t.extensionRequest.date) : '',
      t.fileCount ?? null,
    ];
  });
}
